module.exports = "<ion-content>\n  <ion-button expand=\"full\" (click)=\"openComponent()\">TEST</ion-button>\n</ion-content>\n"